module.exports = __webpack_public_path__ + "media/images/home/testimonials/judy-a9cbba84afa0723896f2069a476de93f.jpg";